import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function SendMessageConfirmModal(props) {
  const { name, isModalShow, handleModalShow } = props;

  return (
    <Modal isOpen={isModalShow} toggle={handleModalShow}>
      <ModalHeader toggle={handleModalShow}>メッセージを送る</ModalHeader>
      <ModalBody>
        <p className='text-center mb-0'>
            次へを押して、メッセージの入力にお進みください
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color='outline-primary' onClick={handleModalShow}>キャンセル</Button>
        {" "}
        <a className='btn btn-primary' href={`/pitches/step1?to=${name}`} role='button'>次へ</a>
      </ModalFooter>
    </Modal>
  );
}

SendMessageConfirmModal.propTypes = {
  name: PropTypes.string.isRequired,
  isModalShow: PropTypes.bool.isRequired,
  handleModalShow: PropTypes.func.isRequired
};

export default SendMessageConfirmModal;
